import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { Button, FAQs, Hint, Image, OrderedList, Paragraph, SemiBold, SubHeader, Table, TagsList, UnorderedList } from '@/components/seo';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(471);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-about-payment-on-delivery");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoPaymentOnDelivery", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 5
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 5>;
      return {
        question: t(`seoPaymentOnDelivery:sections.faqs.${faqIndex}.question`),
        answer: t(`seoPaymentOnDelivery:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoPaymentOnDelivery:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoPaymentOnDelivery:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoPaymentOnDelivery:header.title">{t6}</Trans>;
    t8 = t("seoPaymentOnDelivery:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Paragraph />;
    t11 = <SemiBold />;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      paragraph: t10,
      semibold: t11,
      link1: <Link testId="seoPaymentOnDeliverySection1Link" analyticsParam="seoPaymentOnDeliverySection1Link" to={EXTERNAL_LINKS().stopDobirce} />
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  let t14;
  if ($[19] !== t) {
    t13 = <Trans i18nKey="seoPaymentOnDelivery:sections.1.content" t={t} components={t12} />;
    t14 = t("seoPaymentOnDelivery:sections.1.title");
    $[19] = t;
    $[20] = t13;
    $[21] = t14;
  } else {
    t13 = $[20];
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = {
      content: t13,
      title: t14
    };
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t) {
    t17 = <Trans i18nKey="seoPaymentOnDelivery:sections.2.content" t={t} components={t16} />;
    $[26] = t;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [...Array(7)];
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t) {
    t19 = <OrderedList items={t18.map((value, i) => {
      const transIndex = i + 1 as NumericRange<1, 7>;
      return <Trans key={i} t={t} i18nKey={`seoPaymentOnDelivery:sections.2.list.${transIndex}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[29] = t;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t17 || $[32] !== t19) {
    t20 = <>{t17}{t19}</>;
    $[31] = t17;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t) {
    t21 = t("seoPaymentOnDelivery:sections.2.title");
    $[34] = t;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t20 || $[37] !== t21) {
    t22 = {
      content: t20,
      title: t21
    };
    $[36] = t20;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Paragraph />;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  let t25;
  if ($[40] !== t) {
    t24 = <Trans i18nKey="seoPaymentOnDelivery:sections.3.content" t={t}>{t23}</Trans>;
    t25 = t("seoPaymentOnDelivery:sections.3.title");
    $[40] = t;
    $[41] = t24;
    $[42] = t25;
  } else {
    t24 = $[41];
    t25 = $[42];
  }
  let t26;
  if ($[43] !== t24 || $[44] !== t25) {
    t26 = {
      content: t24,
      title: t25
    };
    $[43] = t24;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Paragraph />;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t) {
    t28 = <Trans i18nKey="seoPaymentOnDelivery:sections.4.content" t={t}>{t27}</Trans>;
    $[47] = t;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = [...Array(5)];
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== t) {
    t30 = t29.map((value_0, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 5>;
      return <Trans key={i_0} t={t} i18nKey={`seoPaymentOnDelivery:sections.4.subsections.${transIndex_0}`} components={{
        paragraph: <Paragraph />,
        subheader: <SubHeader />
      }} />;
    });
    $[50] = t;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t28 || $[53] !== t30) {
    t31 = <>{t28}{t30}</>;
    $[52] = t28;
    $[53] = t30;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== t) {
    t32 = t("seoPaymentOnDelivery:sections.4.title");
    $[55] = t;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t31 || $[58] !== t32) {
    t33 = {
      content: t31,
      title: t32
    };
    $[57] = t31;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  let t35;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Paragraph />;
    t35 = <SemiBold />;
    $[60] = t34;
    $[61] = t35;
  } else {
    t34 = $[60];
    t35 = $[61];
  }
  let t36;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      paragraph: t34,
      semibold: t35,
      link1: <Link testId="seoPaymentOnDeliverySection5Link" analyticsParam="seoPaymentOnDeliverySection5Link" to={EXTERNAL_LINKS().stopDobirce} />
    };
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  let t37;
  if ($[63] !== t) {
    t37 = <Trans i18nKey="seoPaymentOnDelivery:sections.5.content" t={t} components={t36} />;
    $[63] = t;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      link1: <Link analyticsParam="seoPaymentOnDeliveryHintDeferredPayment5Link" testId="seoPaymentOnDeliveryHintDeferredPayment5Link" to={EXTERNAL_LINKS().stopDobirce} />
    };
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] !== t) {
    t39 = <Hint text={<Trans t={t} i18nKey="seoPaymentOnDelivery:sections.5.hint" components={t38} />} />;
    $[66] = t;
    $[67] = t39;
  } else {
    t39 = $[67];
  }
  let t40;
  if ($[68] !== t37 || $[69] !== t39) {
    t40 = <>{t37}{t39}</>;
    $[68] = t37;
    $[69] = t39;
    $[70] = t40;
  } else {
    t40 = $[70];
  }
  let t41;
  if ($[71] !== t) {
    t41 = t("seoPaymentOnDelivery:sections.5.title");
    $[71] = t;
    $[72] = t41;
  } else {
    t41 = $[72];
  }
  let t42;
  if ($[73] !== t40 || $[74] !== t41) {
    t42 = {
      content: t40,
      title: t41
    };
    $[73] = t40;
    $[74] = t41;
    $[75] = t42;
  } else {
    t42 = $[75];
  }
  let t43;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      paragraph: <Paragraph />
    };
    $[76] = t43;
  } else {
    t43 = $[76];
  }
  let t44;
  if ($[77] !== t) {
    t44 = <Trans i18nKey="seoPaymentOnDelivery:sections.6.content" t={t} components={t43} />;
    $[77] = t;
    $[78] = t44;
  } else {
    t44 = $[78];
  }
  let t45;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = [...Array(4)];
    $[79] = t45;
  } else {
    t45 = $[79];
  }
  let t46;
  if ($[80] !== t) {
    t46 = <UnorderedList items={t45.map((value_1, i_1) => {
      const transIndex_1 = i_1 + 1 as NumericRange<1, 4>;
      return <Trans key={i_1} t={t} i18nKey={`seoPaymentOnDelivery:sections.6.list.${transIndex_1}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[80] = t;
    $[81] = t46;
  } else {
    t46 = $[81];
  }
  let t47;
  if ($[82] !== t44 || $[83] !== t46) {
    t47 = <>{t44}{t46}</>;
    $[82] = t44;
    $[83] = t46;
    $[84] = t47;
  } else {
    t47 = $[84];
  }
  let t48;
  if ($[85] !== t) {
    t48 = t("seoPaymentOnDelivery:sections.6.title");
    $[85] = t;
    $[86] = t48;
  } else {
    t48 = $[86];
  }
  let t49;
  if ($[87] !== t47 || $[88] !== t48) {
    t49 = {
      content: t47,
      title: t48
    };
    $[87] = t47;
    $[88] = t48;
    $[89] = t49;
  } else {
    t49 = $[89];
  }
  let t50;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = {
      paragraph: <Paragraph />
    };
    $[90] = t50;
  } else {
    t50 = $[90];
  }
  let t51;
  if ($[91] !== t) {
    t51 = <Trans i18nKey="seoPaymentOnDelivery:sections.7.content1" t={t} components={t50} />;
    $[91] = t;
    $[92] = t51;
  } else {
    t51 = $[92];
  }
  let t52;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = [...Array(8)];
    $[93] = t52;
  } else {
    t52 = $[93];
  }
  let t53;
  if ($[94] !== t) {
    t53 = <TagsList items={t52.map((value_2, i_2) => {
      const transIndex_2 = i_2 + 1 as NumericRange<1, 8>;
      return <Trans key={i_2} t={t} i18nKey={`seoPaymentOnDelivery:sections.7.list1.${transIndex_2}`} />;
    })} className="mb-6 lg:mb-8" />;
    $[94] = t;
    $[95] = t53;
  } else {
    t53 = $[95];
  }
  let t54;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = {
      paragraph: <Paragraph />
    };
    $[96] = t54;
  } else {
    t54 = $[96];
  }
  let t55;
  if ($[97] !== t) {
    t55 = <Trans i18nKey="seoPaymentOnDelivery:sections.7.content2" t={t} components={t54} />;
    $[97] = t;
    $[98] = t55;
  } else {
    t55 = $[98];
  }
  let t56;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = [...Array(3)];
    $[99] = t56;
  } else {
    t56 = $[99];
  }
  let t57;
  if ($[100] !== t) {
    t57 = <TagsList items={t56.map((value_3, i_3) => {
      const transIndex_3 = i_3 + 1 as NumericRange<1, 3>;
      return <Trans key={i_3} t={t} i18nKey={`seoPaymentOnDelivery:sections.7.list2.${transIndex_3}`} />;
    })} />;
    $[100] = t;
    $[101] = t57;
  } else {
    t57 = $[101];
  }
  let t58;
  if ($[102] !== t51 || $[103] !== t53 || $[104] !== t55 || $[105] !== t57) {
    t58 = <>{t51}{t53}{t55}{t57}</>;
    $[102] = t51;
    $[103] = t53;
    $[104] = t55;
    $[105] = t57;
    $[106] = t58;
  } else {
    t58 = $[106];
  }
  let t59;
  if ($[107] !== t) {
    t59 = t("seoPaymentOnDelivery:sections.7.title");
    $[107] = t;
    $[108] = t59;
  } else {
    t59 = $[108];
  }
  let t60;
  if ($[109] !== t58 || $[110] !== t59) {
    t60 = {
      content: t58,
      title: t59
    };
    $[109] = t58;
    $[110] = t59;
    $[111] = t60;
  } else {
    t60 = $[111];
  }
  let t61;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = {
      paragraph: <Paragraph />
    };
    $[112] = t61;
  } else {
    t61 = $[112];
  }
  let t62;
  if ($[113] !== t) {
    t62 = <Trans i18nKey="seoPaymentOnDelivery:sections.8.content1" t={t} components={t61} />;
    $[113] = t;
    $[114] = t62;
  } else {
    t62 = $[114];
  }
  let t63;
  if ($[115] !== t) {
    t63 = t("seoPaymentOnDelivery:sections.8.table.header");
    $[115] = t;
    $[116] = t63;
  } else {
    t63 = $[116];
  }
  let t64;
  if ($[117] !== t63) {
    t64 = <tr><th colSpan={7} className="w-192">{t63}</th></tr>;
    $[117] = t63;
    $[118] = t64;
  } else {
    t64 = $[118];
  }
  let t65;
  if ($[119] !== t) {
    t65 = t("seoPaymentOnDelivery:sections.8.table.sections.1.title");
    $[119] = t;
    $[120] = t65;
  } else {
    t65 = $[120];
  }
  let t66;
  if ($[121] !== t65) {
    t66 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t65}</td></tr>;
    $[121] = t65;
    $[122] = t66;
  } else {
    t66 = $[122];
  }
  let t67;
  if ($[123] !== t) {
    t67 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.1");
    $[123] = t;
    $[124] = t67;
  } else {
    t67 = $[124];
  }
  let t68;
  if ($[125] !== t67) {
    t68 = <td className="w-42">{t67}</td>;
    $[125] = t67;
    $[126] = t68;
  } else {
    t68 = $[126];
  }
  let t69;
  if ($[127] !== t) {
    t69 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.2");
    $[127] = t;
    $[128] = t69;
  } else {
    t69 = $[128];
  }
  let t70;
  if ($[129] !== t69) {
    t70 = <td colSpan={2} className="w-50">{t69}</td>;
    $[129] = t69;
    $[130] = t70;
  } else {
    t70 = $[130];
  }
  let t71;
  if ($[131] !== t) {
    t71 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.3");
    $[131] = t;
    $[132] = t71;
  } else {
    t71 = $[132];
  }
  let t72;
  if ($[133] !== t71) {
    t72 = <td colSpan={2} className="w-50">{t71}</td>;
    $[133] = t71;
    $[134] = t72;
  } else {
    t72 = $[134];
  }
  let t73;
  if ($[135] !== t) {
    t73 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.4");
    $[135] = t;
    $[136] = t73;
  } else {
    t73 = $[136];
  }
  let t74;
  if ($[137] !== t73) {
    t74 = <td colSpan={2} className="w-50">{t73}</td>;
    $[137] = t73;
    $[138] = t74;
  } else {
    t74 = $[138];
  }
  let t75;
  if ($[139] !== t68 || $[140] !== t70 || $[141] !== t72 || $[142] !== t74) {
    t75 = <tr>{t68}{t70}{t72}{t74}</tr>;
    $[139] = t68;
    $[140] = t70;
    $[141] = t72;
    $[142] = t74;
    $[143] = t75;
  } else {
    t75 = $[143];
  }
  let t76;
  if ($[144] !== t) {
    t76 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.1");
    $[144] = t;
    $[145] = t76;
  } else {
    t76 = $[145];
  }
  let t77;
  if ($[146] !== t76) {
    t77 = <td className="w-42">{t76}</td>;
    $[146] = t76;
    $[147] = t77;
  } else {
    t77 = $[147];
  }
  let t78;
  if ($[148] !== t) {
    t78 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.2");
    $[148] = t;
    $[149] = t78;
  } else {
    t78 = $[149];
  }
  let t79;
  if ($[150] !== t78) {
    t79 = <td colSpan={2} className="w-50">{t78}</td>;
    $[150] = t78;
    $[151] = t79;
  } else {
    t79 = $[151];
  }
  let t80;
  if ($[152] !== t) {
    t80 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.3");
    $[152] = t;
    $[153] = t80;
  } else {
    t80 = $[153];
  }
  let t81;
  if ($[154] !== t80) {
    t81 = <td colSpan={2} className="w-50">{t80}</td>;
    $[154] = t80;
    $[155] = t81;
  } else {
    t81 = $[155];
  }
  let t82;
  if ($[156] !== t) {
    t82 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.4");
    $[156] = t;
    $[157] = t82;
  } else {
    t82 = $[157];
  }
  let t83;
  if ($[158] !== t82) {
    t83 = <td colSpan={2} className="w-50">{t82}</td>;
    $[158] = t82;
    $[159] = t83;
  } else {
    t83 = $[159];
  }
  let t84;
  if ($[160] !== t77 || $[161] !== t79 || $[162] !== t81 || $[163] !== t83) {
    t84 = <tr>{t77}{t79}{t81}{t83}</tr>;
    $[160] = t77;
    $[161] = t79;
    $[162] = t81;
    $[163] = t83;
    $[164] = t84;
  } else {
    t84 = $[164];
  }
  let t85;
  if ($[165] !== t) {
    t85 = t("seoPaymentOnDelivery:sections.8.table.sections.2.title");
    $[165] = t;
    $[166] = t85;
  } else {
    t85 = $[166];
  }
  let t86;
  if ($[167] !== t85) {
    t86 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t85}</td></tr>;
    $[167] = t85;
    $[168] = t86;
  } else {
    t86 = $[168];
  }
  let t87;
  if ($[169] !== t) {
    t87 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.1");
    $[169] = t;
    $[170] = t87;
  } else {
    t87 = $[170];
  }
  let t88;
  if ($[171] !== t87) {
    t88 = <td className="w-42">{t87}</td>;
    $[171] = t87;
    $[172] = t88;
  } else {
    t88 = $[172];
  }
  let t89;
  if ($[173] !== t) {
    t89 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.2");
    $[173] = t;
    $[174] = t89;
  } else {
    t89 = $[174];
  }
  let t90;
  if ($[175] !== t89) {
    t90 = <td className="w-25">{t89}</td>;
    $[175] = t89;
    $[176] = t90;
  } else {
    t90 = $[176];
  }
  let t91;
  if ($[177] !== t) {
    t91 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.3");
    $[177] = t;
    $[178] = t91;
  } else {
    t91 = $[178];
  }
  let t92;
  if ($[179] !== t91) {
    t92 = <td className="w-25">{t91}</td>;
    $[179] = t91;
    $[180] = t92;
  } else {
    t92 = $[180];
  }
  let t93;
  if ($[181] !== t) {
    t93 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.4");
    $[181] = t;
    $[182] = t93;
  } else {
    t93 = $[182];
  }
  let t94;
  if ($[183] !== t93) {
    t94 = <td className="w-25">{t93}</td>;
    $[183] = t93;
    $[184] = t94;
  } else {
    t94 = $[184];
  }
  let t95;
  if ($[185] !== t) {
    t95 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.5");
    $[185] = t;
    $[186] = t95;
  } else {
    t95 = $[186];
  }
  let t96;
  if ($[187] !== t95) {
    t96 = <td className="w-25">{t95}</td>;
    $[187] = t95;
    $[188] = t96;
  } else {
    t96 = $[188];
  }
  let t97;
  if ($[189] !== t) {
    t97 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.6");
    $[189] = t;
    $[190] = t97;
  } else {
    t97 = $[190];
  }
  let t98;
  if ($[191] !== t97) {
    t98 = <td className="w-25">{t97}</td>;
    $[191] = t97;
    $[192] = t98;
  } else {
    t98 = $[192];
  }
  let t99;
  if ($[193] !== t) {
    t99 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.7");
    $[193] = t;
    $[194] = t99;
  } else {
    t99 = $[194];
  }
  let t100;
  if ($[195] !== t99) {
    t100 = <td className="w-25">{t99}</td>;
    $[195] = t99;
    $[196] = t100;
  } else {
    t100 = $[196];
  }
  let t101;
  if ($[197] !== t100 || $[198] !== t88 || $[199] !== t90 || $[200] !== t92 || $[201] !== t94 || $[202] !== t96 || $[203] !== t98) {
    t101 = <tr>{t88}{t90}{t92}{t94}{t96}{t98}{t100}</tr>;
    $[197] = t100;
    $[198] = t88;
    $[199] = t90;
    $[200] = t92;
    $[201] = t94;
    $[202] = t96;
    $[203] = t98;
    $[204] = t101;
  } else {
    t101 = $[204];
  }
  let t102;
  if ($[205] !== t) {
    t102 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.1");
    $[205] = t;
    $[206] = t102;
  } else {
    t102 = $[206];
  }
  let t103;
  if ($[207] !== t102) {
    t103 = <td className="w-42">{t102}</td>;
    $[207] = t102;
    $[208] = t103;
  } else {
    t103 = $[208];
  }
  let t104;
  if ($[209] !== t) {
    t104 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.2");
    $[209] = t;
    $[210] = t104;
  } else {
    t104 = $[210];
  }
  let t105;
  if ($[211] !== t104) {
    t105 = <td className="w-25">{t104}</td>;
    $[211] = t104;
    $[212] = t105;
  } else {
    t105 = $[212];
  }
  let t106;
  if ($[213] !== t) {
    t106 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.3");
    $[213] = t;
    $[214] = t106;
  } else {
    t106 = $[214];
  }
  let t107;
  if ($[215] !== t106) {
    t107 = <td className="w-25">{t106}</td>;
    $[215] = t106;
    $[216] = t107;
  } else {
    t107 = $[216];
  }
  let t108;
  if ($[217] !== t) {
    t108 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.4");
    $[217] = t;
    $[218] = t108;
  } else {
    t108 = $[218];
  }
  let t109;
  if ($[219] !== t108) {
    t109 = <td className="w-25">{t108}</td>;
    $[219] = t108;
    $[220] = t109;
  } else {
    t109 = $[220];
  }
  let t110;
  if ($[221] !== t) {
    t110 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.5");
    $[221] = t;
    $[222] = t110;
  } else {
    t110 = $[222];
  }
  let t111;
  if ($[223] !== t110) {
    t111 = <td className="w-25">{t110}</td>;
    $[223] = t110;
    $[224] = t111;
  } else {
    t111 = $[224];
  }
  let t112;
  if ($[225] !== t) {
    t112 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.6");
    $[225] = t;
    $[226] = t112;
  } else {
    t112 = $[226];
  }
  let t113;
  if ($[227] !== t112) {
    t113 = <td className="w-25">{t112}</td>;
    $[227] = t112;
    $[228] = t113;
  } else {
    t113 = $[228];
  }
  let t114;
  if ($[229] !== t) {
    t114 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.7");
    $[229] = t;
    $[230] = t114;
  } else {
    t114 = $[230];
  }
  let t115;
  if ($[231] !== t114) {
    t115 = <td className="w-25">{t114}</td>;
    $[231] = t114;
    $[232] = t115;
  } else {
    t115 = $[232];
  }
  let t116;
  if ($[233] !== t103 || $[234] !== t105 || $[235] !== t107 || $[236] !== t109 || $[237] !== t111 || $[238] !== t113 || $[239] !== t115) {
    t116 = <tr>{t103}{t105}{t107}{t109}{t111}{t113}{t115}</tr>;
    $[233] = t103;
    $[234] = t105;
    $[235] = t107;
    $[236] = t109;
    $[237] = t111;
    $[238] = t113;
    $[239] = t115;
    $[240] = t116;
  } else {
    t116 = $[240];
  }
  let t117;
  if ($[241] !== t) {
    t117 = t("seoPaymentOnDelivery:sections.8.table.sections.3.title");
    $[241] = t;
    $[242] = t117;
  } else {
    t117 = $[242];
  }
  let t118;
  if ($[243] !== t117) {
    t118 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t117}</td></tr>;
    $[243] = t117;
    $[244] = t118;
  } else {
    t118 = $[244];
  }
  let t119;
  if ($[245] !== t) {
    t119 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.1");
    $[245] = t;
    $[246] = t119;
  } else {
    t119 = $[246];
  }
  let t120;
  if ($[247] !== t119) {
    t120 = <td className="w-42">{t119}</td>;
    $[247] = t119;
    $[248] = t120;
  } else {
    t120 = $[248];
  }
  let t121;
  if ($[249] !== t) {
    t121 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.2");
    $[249] = t;
    $[250] = t121;
  } else {
    t121 = $[250];
  }
  let t122;
  if ($[251] !== t121) {
    t122 = <td className="w-25">{t121}</td>;
    $[251] = t121;
    $[252] = t122;
  } else {
    t122 = $[252];
  }
  let t123;
  if ($[253] !== t) {
    t123 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.3");
    $[253] = t;
    $[254] = t123;
  } else {
    t123 = $[254];
  }
  let t124;
  if ($[255] !== t123) {
    t124 = <td className="w-25">{t123}</td>;
    $[255] = t123;
    $[256] = t124;
  } else {
    t124 = $[256];
  }
  let t125;
  if ($[257] !== t) {
    t125 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.4");
    $[257] = t;
    $[258] = t125;
  } else {
    t125 = $[258];
  }
  let t126;
  if ($[259] !== t125) {
    t126 = <td className="w-25">{t125}</td>;
    $[259] = t125;
    $[260] = t126;
  } else {
    t126 = $[260];
  }
  let t127;
  if ($[261] !== t) {
    t127 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.5");
    $[261] = t;
    $[262] = t127;
  } else {
    t127 = $[262];
  }
  let t128;
  if ($[263] !== t127) {
    t128 = <td className="w-25">{t127}</td>;
    $[263] = t127;
    $[264] = t128;
  } else {
    t128 = $[264];
  }
  let t129;
  if ($[265] !== t) {
    t129 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.6");
    $[265] = t;
    $[266] = t129;
  } else {
    t129 = $[266];
  }
  let t130;
  if ($[267] !== t129) {
    t130 = <td className="w-25">{t129}</td>;
    $[267] = t129;
    $[268] = t130;
  } else {
    t130 = $[268];
  }
  let t131;
  if ($[269] !== t) {
    t131 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.7");
    $[269] = t;
    $[270] = t131;
  } else {
    t131 = $[270];
  }
  let t132;
  if ($[271] !== t131) {
    t132 = <td className="w-25">{t131}</td>;
    $[271] = t131;
    $[272] = t132;
  } else {
    t132 = $[272];
  }
  let t133;
  if ($[273] !== t120 || $[274] !== t122 || $[275] !== t124 || $[276] !== t126 || $[277] !== t128 || $[278] !== t130 || $[279] !== t132) {
    t133 = <tr>{t120}{t122}{t124}{t126}{t128}{t130}{t132}</tr>;
    $[273] = t120;
    $[274] = t122;
    $[275] = t124;
    $[276] = t126;
    $[277] = t128;
    $[278] = t130;
    $[279] = t132;
    $[280] = t133;
  } else {
    t133 = $[280];
  }
  let t134;
  if ($[281] !== t) {
    t134 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.1");
    $[281] = t;
    $[282] = t134;
  } else {
    t134 = $[282];
  }
  let t135;
  if ($[283] !== t134) {
    t135 = <td className="w-42">{t134}</td>;
    $[283] = t134;
    $[284] = t135;
  } else {
    t135 = $[284];
  }
  let t136;
  if ($[285] !== t) {
    t136 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.2");
    $[285] = t;
    $[286] = t136;
  } else {
    t136 = $[286];
  }
  let t137;
  if ($[287] !== t136) {
    t137 = <td className="w-25">{t136}</td>;
    $[287] = t136;
    $[288] = t137;
  } else {
    t137 = $[288];
  }
  let t138;
  if ($[289] !== t) {
    t138 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.3");
    $[289] = t;
    $[290] = t138;
  } else {
    t138 = $[290];
  }
  let t139;
  if ($[291] !== t138) {
    t139 = <td className="w-25">{t138}</td>;
    $[291] = t138;
    $[292] = t139;
  } else {
    t139 = $[292];
  }
  let t140;
  if ($[293] !== t) {
    t140 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.4");
    $[293] = t;
    $[294] = t140;
  } else {
    t140 = $[294];
  }
  let t141;
  if ($[295] !== t140) {
    t141 = <td className="w-25">{t140}</td>;
    $[295] = t140;
    $[296] = t141;
  } else {
    t141 = $[296];
  }
  let t142;
  if ($[297] !== t) {
    t142 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.5");
    $[297] = t;
    $[298] = t142;
  } else {
    t142 = $[298];
  }
  let t143;
  if ($[299] !== t142) {
    t143 = <td className="w-25">{t142}</td>;
    $[299] = t142;
    $[300] = t143;
  } else {
    t143 = $[300];
  }
  let t144;
  if ($[301] !== t) {
    t144 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.6");
    $[301] = t;
    $[302] = t144;
  } else {
    t144 = $[302];
  }
  let t145;
  if ($[303] !== t144) {
    t145 = <td className="w-25">{t144}</td>;
    $[303] = t144;
    $[304] = t145;
  } else {
    t145 = $[304];
  }
  let t146;
  if ($[305] !== t) {
    t146 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.7");
    $[305] = t;
    $[306] = t146;
  } else {
    t146 = $[306];
  }
  let t147;
  if ($[307] !== t146) {
    t147 = <td className="w-25">{t146}</td>;
    $[307] = t146;
    $[308] = t147;
  } else {
    t147 = $[308];
  }
  let t148;
  if ($[309] !== t135 || $[310] !== t137 || $[311] !== t139 || $[312] !== t141 || $[313] !== t143 || $[314] !== t145 || $[315] !== t147) {
    t148 = <tr>{t135}{t137}{t139}{t141}{t143}{t145}{t147}</tr>;
    $[309] = t135;
    $[310] = t137;
    $[311] = t139;
    $[312] = t141;
    $[313] = t143;
    $[314] = t145;
    $[315] = t147;
    $[316] = t148;
  } else {
    t148 = $[316];
  }
  let t149;
  if ($[317] !== t) {
    t149 = t("seoPaymentOnDelivery:sections.8.table.sections.4.title");
    $[317] = t;
    $[318] = t149;
  } else {
    t149 = $[318];
  }
  let t150;
  if ($[319] !== t149) {
    t150 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t149}</td></tr>;
    $[319] = t149;
    $[320] = t150;
  } else {
    t150 = $[320];
  }
  let t151;
  if ($[321] !== t) {
    t151 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.1.columns.1");
    $[321] = t;
    $[322] = t151;
  } else {
    t151 = $[322];
  }
  let t152;
  if ($[323] !== t151) {
    t152 = <td className="w-42">{t151}</td>;
    $[323] = t151;
    $[324] = t152;
  } else {
    t152 = $[324];
  }
  let t153;
  if ($[325] !== t) {
    t153 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.1.columns.2");
    $[325] = t;
    $[326] = t153;
  } else {
    t153 = $[326];
  }
  let t154;
  if ($[327] !== t153) {
    t154 = <td colSpan={6} className="w-[37.5rem]">{t153}</td>;
    $[327] = t153;
    $[328] = t154;
  } else {
    t154 = $[328];
  }
  let t155;
  if ($[329] !== t152 || $[330] !== t154) {
    t155 = <tr>{t152}{t154}</tr>;
    $[329] = t152;
    $[330] = t154;
    $[331] = t155;
  } else {
    t155 = $[331];
  }
  let t156;
  if ($[332] !== t) {
    t156 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.2.columns.1");
    $[332] = t;
    $[333] = t156;
  } else {
    t156 = $[333];
  }
  let t157;
  if ($[334] !== t156) {
    t157 = <td className="w-42">{t156}</td>;
    $[334] = t156;
    $[335] = t157;
  } else {
    t157 = $[335];
  }
  let t158;
  if ($[336] !== t) {
    t158 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.2.columns.2");
    $[336] = t;
    $[337] = t158;
  } else {
    t158 = $[337];
  }
  let t159;
  if ($[338] !== t158) {
    t159 = <td colSpan={6} className="w-[37.5rem]">{t158}</td>;
    $[338] = t158;
    $[339] = t159;
  } else {
    t159 = $[339];
  }
  let t160;
  if ($[340] !== t157 || $[341] !== t159) {
    t160 = <tr>{t157}{t159}</tr>;
    $[340] = t157;
    $[341] = t159;
    $[342] = t160;
  } else {
    t160 = $[342];
  }
  let t161;
  if ($[343] !== t101 || $[344] !== t116 || $[345] !== t118 || $[346] !== t133 || $[347] !== t148 || $[348] !== t150 || $[349] !== t155 || $[350] !== t160 || $[351] !== t66 || $[352] !== t75 || $[353] !== t84 || $[354] !== t86) {
    t161 = <>{t66}{t75}{t84}{t86}{t101}{t116}{t118}{t133}{t148}{t150}{t155}{t160}</>;
    $[343] = t101;
    $[344] = t116;
    $[345] = t118;
    $[346] = t133;
    $[347] = t148;
    $[348] = t150;
    $[349] = t155;
    $[350] = t160;
    $[351] = t66;
    $[352] = t75;
    $[353] = t84;
    $[354] = t86;
    $[355] = t161;
  } else {
    t161 = $[355];
  }
  let t162;
  if ($[356] !== t) {
    t162 = t("seoPaymentOnDelivery:sections.8.table.note");
    $[356] = t;
    $[357] = t162;
  } else {
    t162 = $[357];
  }
  let t163;
  if ($[358] !== t162) {
    t163 = [t162];
    $[358] = t162;
    $[359] = t163;
  } else {
    t163 = $[359];
  }
  let t164;
  if ($[360] !== t161 || $[361] !== t163 || $[362] !== t64) {
    t164 = <Table head={t64} body={t161} notes={t163} className="mb-6 lg:mb-8" />;
    $[360] = t161;
    $[361] = t163;
    $[362] = t64;
    $[363] = t164;
  } else {
    t164 = $[363];
  }
  let t165;
  if ($[364] === Symbol.for("react.memo_cache_sentinel")) {
    t165 = {
      paragraph: <Paragraph />
    };
    $[364] = t165;
  } else {
    t165 = $[364];
  }
  let t166;
  if ($[365] !== t) {
    t166 = <Trans i18nKey="seoPaymentOnDelivery:sections.8.content2" t={t} components={t165} />;
    $[365] = t;
    $[366] = t166;
  } else {
    t166 = $[366];
  }
  let t167;
  if ($[367] === Symbol.for("react.memo_cache_sentinel")) {
    t167 = {
      link1: <Link analyticsParam="seoPaymentOnDeliveryHintDeferredPayment" testId="seoPaymentOnDeliveryHintDeferredPayment" to={LINKS().aboutDeferredPayment} />
    };
    $[367] = t167;
  } else {
    t167 = $[367];
  }
  let t168;
  if ($[368] !== t) {
    t168 = <Hint text={<Trans t={t} i18nKey="seoPaymentOnDelivery:sections.8.hint" components={t167} />} />;
    $[368] = t;
    $[369] = t168;
  } else {
    t168 = $[369];
  }
  let t169;
  if ($[370] !== t164 || $[371] !== t166 || $[372] !== t168 || $[373] !== t62) {
    t169 = <>{t62}{t164}{t166}{t168}</>;
    $[370] = t164;
    $[371] = t166;
    $[372] = t168;
    $[373] = t62;
    $[374] = t169;
  } else {
    t169 = $[374];
  }
  let t170;
  if ($[375] !== t) {
    t170 = t("seoPaymentOnDelivery:sections.8.title");
    $[375] = t;
    $[376] = t170;
  } else {
    t170 = $[376];
  }
  let t171;
  if ($[377] !== t169 || $[378] !== t170) {
    t171 = {
      content: t169,
      title: t170
    };
    $[377] = t169;
    $[378] = t170;
    $[379] = t171;
  } else {
    t171 = $[379];
  }
  let t172;
  if ($[380] === Symbol.for("react.memo_cache_sentinel")) {
    t172 = [...Array(4)];
    $[380] = t172;
  } else {
    t172 = $[380];
  }
  let t173;
  let t174;
  if ($[381] !== t) {
    t173 = <OrderedList items={t172.map((__0, i_4) => {
      const transIndex_4 = i_4 + 1 as NumericRange<1, 4>;
      return <Trans key={i_4} t={t} i18nKey={`seoPaymentOnDelivery:sections.9.list.${transIndex_4}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    t174 = t("seoPaymentOnDelivery:sections.9.title");
    $[381] = t;
    $[382] = t173;
    $[383] = t174;
  } else {
    t173 = $[382];
    t174 = $[383];
  }
  let t175;
  if ($[384] !== t173 || $[385] !== t174) {
    t175 = {
      content: t173,
      title: t174
    };
    $[384] = t173;
    $[385] = t174;
    $[386] = t175;
  } else {
    t175 = $[386];
  }
  let t176;
  if ($[387] === Symbol.for("react.memo_cache_sentinel")) {
    t176 = [...Array(4)];
    $[387] = t176;
  } else {
    t176 = $[387];
  }
  let t177;
  let t178;
  if ($[388] !== t) {
    t177 = <OrderedList items={t176.map((__1, i_5) => {
      const transIndex_5 = i_5 + 1 as NumericRange<1, 4>;
      return <Trans key={i_5} t={t} i18nKey={`seoPaymentOnDelivery:sections.10.list.${transIndex_5}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    t178 = t("seoPaymentOnDelivery:sections.10.title");
    $[388] = t;
    $[389] = t177;
    $[390] = t178;
  } else {
    t177 = $[389];
    t178 = $[390];
  }
  let t179;
  if ($[391] !== t177 || $[392] !== t178) {
    t179 = {
      content: t177,
      title: t178
    };
    $[391] = t177;
    $[392] = t178;
    $[393] = t179;
  } else {
    t179 = $[393];
  }
  let t180;
  if ($[394] === Symbol.for("react.memo_cache_sentinel")) {
    t180 = {
      paragraph: <Paragraph />,
      link1: <Link testId="seoPaymentOnDeliveryPost" analyticsParam="seoPaymentOnDeliveryPost" to="https://www.ceskaposta.cz/sluzby/platebni-a-financni-sluzby-cr/postovni-poukazka-a" target="_blank" />,
      link2: <Link testId="seoPaymentOnDeliveryPost2" analyticsParam="seoPaymentOnDeliveryPost2" to="https://www.ceskaposta.cz/sluzby/platebni-a-financni-sluzby-cr/postovni-poukazka-c" target="_blank" />
    };
    $[394] = t180;
  } else {
    t180 = $[394];
  }
  let t181;
  if ($[395] !== t) {
    t181 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.11.content" components={t180} />;
    $[395] = t;
    $[396] = t181;
  } else {
    t181 = $[396];
  }
  let t182;
  if ($[397] !== t) {
    t182 = t("seoPaymentOnDelivery:sections.11.title");
    $[397] = t;
    $[398] = t182;
  } else {
    t182 = $[398];
  }
  let t183;
  if ($[399] !== t182) {
    t183 = <Image src="/images/sections/seoPaymentOnDelivery/cs/post.png" width={768} height={325} alt={t182} />;
    $[399] = t182;
    $[400] = t183;
  } else {
    t183 = $[400];
  }
  let t184;
  if ($[401] !== t181 || $[402] !== t183) {
    t184 = <>{t181}{t183}</>;
    $[401] = t181;
    $[402] = t183;
    $[403] = t184;
  } else {
    t184 = $[403];
  }
  let t185;
  if ($[404] !== t) {
    t185 = t("seoPaymentOnDelivery:sections.11.title");
    $[404] = t;
    $[405] = t185;
  } else {
    t185 = $[405];
  }
  let t186;
  if ($[406] !== t184 || $[407] !== t185) {
    t186 = {
      content: t184,
      title: t185
    };
    $[406] = t184;
    $[407] = t185;
    $[408] = t186;
  } else {
    t186 = $[408];
  }
  let t187;
  if ($[409] === Symbol.for("react.memo_cache_sentinel")) {
    t187 = {
      paragraph: <Paragraph />
    };
    $[409] = t187;
  } else {
    t187 = $[409];
  }
  let t188;
  let t189;
  if ($[410] !== t) {
    t188 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.12.content" components={t187} />;
    t189 = t("seoPaymentOnDelivery:sections.12.title");
    $[410] = t;
    $[411] = t188;
    $[412] = t189;
  } else {
    t188 = $[411];
    t189 = $[412];
  }
  let t190;
  if ($[413] !== t188 || $[414] !== t189) {
    t190 = {
      content: t188,
      title: t189
    };
    $[413] = t188;
    $[414] = t189;
    $[415] = t190;
  } else {
    t190 = $[415];
  }
  let t191;
  if ($[416] === Symbol.for("react.memo_cache_sentinel")) {
    t191 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[416] = t191;
  } else {
    t191 = $[416];
  }
  let t192;
  let t193;
  if ($[417] !== t) {
    t192 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.13.content" components={t191} />;
    t193 = t("seoPaymentOnDelivery:sections.13.title");
    $[417] = t;
    $[418] = t192;
    $[419] = t193;
  } else {
    t192 = $[418];
    t193 = $[419];
  }
  let t194;
  if ($[420] !== t192 || $[421] !== t193) {
    t194 = {
      content: t192,
      title: t193
    };
    $[420] = t192;
    $[421] = t193;
    $[422] = t194;
  } else {
    t194 = $[422];
  }
  let t195;
  let t196;
  let t197;
  if ($[423] === Symbol.for("react.memo_cache_sentinel")) {
    t195 = <Paragraph />;
    t196 = <SemiBold />;
    t197 = <br />;
    $[423] = t195;
    $[424] = t196;
    $[425] = t197;
  } else {
    t195 = $[423];
    t196 = $[424];
    t197 = $[425];
  }
  let t198;
  if ($[426] === Symbol.for("react.memo_cache_sentinel")) {
    t198 = {
      paragraph: t195,
      semibold: t196,
      br: t197,
      link1: <Link testId="seoPaymentOnDeliverySection14Link" analyticsParam="seoPaymentOnDeliverySection14Link" to={EXTERNAL_LINKS().stopDobirce} />
    };
    $[426] = t198;
  } else {
    t198 = $[426];
  }
  let t199;
  if ($[427] !== t) {
    t199 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.14.content" components={t198} />;
    $[427] = t;
    $[428] = t199;
  } else {
    t199 = $[428];
  }
  let t200;
  if ($[429] === Symbol.for("react.memo_cache_sentinel")) {
    t200 = LINKS();
    $[429] = t200;
  } else {
    t200 = $[429];
  }
  const t201 = t200.registration;
  let t202;
  if ($[430] !== t) {
    t202 = t("seoPaymentOnDelivery:sections.14.button");
    $[430] = t;
    $[431] = t202;
  } else {
    t202 = $[431];
  }
  let t203;
  if ($[432] !== t202) {
    t203 = <Button analyticsParam="seoPaymentOnDeliveryRegistration" testId="seoPaymentOnDeliveryRegistration" to={t201} variant="primary">{t202}</Button>;
    $[432] = t202;
    $[433] = t203;
  } else {
    t203 = $[433];
  }
  let t204;
  if ($[434] !== t199 || $[435] !== t203) {
    t204 = <>{t199}{t203}</>;
    $[434] = t199;
    $[435] = t203;
    $[436] = t204;
  } else {
    t204 = $[436];
  }
  let t205;
  if ($[437] !== t) {
    t205 = t("seoPaymentOnDelivery:sections.14.title");
    $[437] = t;
    $[438] = t205;
  } else {
    t205 = $[438];
  }
  let t206;
  if ($[439] !== t204 || $[440] !== t205) {
    t206 = {
      content: t204,
      title: t205
    };
    $[439] = t204;
    $[440] = t205;
    $[441] = t206;
  } else {
    t206 = $[441];
  }
  let t207;
  if ($[442] !== faqsData) {
    t207 = <FAQs data={faqsData} />;
    $[442] = faqsData;
    $[443] = t207;
  } else {
    t207 = $[443];
  }
  let t208;
  if ($[444] !== t) {
    t208 = t("core:faqs.title");
    $[444] = t;
    $[445] = t208;
  } else {
    t208 = $[445];
  }
  let t209;
  if ($[446] !== t207 || $[447] !== t208) {
    t209 = {
      content: t207,
      title: t208
    };
    $[446] = t207;
    $[447] = t208;
    $[448] = t209;
  } else {
    t209 = $[448];
  }
  let t210;
  if ($[449] !== t15 || $[450] !== t171 || $[451] !== t175 || $[452] !== t179 || $[453] !== t186 || $[454] !== t190 || $[455] !== t194 || $[456] !== t206 || $[457] !== t209 || $[458] !== t22 || $[459] !== t26 || $[460] !== t33 || $[461] !== t42 || $[462] !== t49 || $[463] !== t60) {
    t210 = [t15, t22, t26, t33, t42, t49, t60, t171, t175, t179, t186, t190, t194, t206, t209];
    $[449] = t15;
    $[450] = t171;
    $[451] = t175;
    $[452] = t179;
    $[453] = t186;
    $[454] = t190;
    $[455] = t194;
    $[456] = t206;
    $[457] = t209;
    $[458] = t22;
    $[459] = t26;
    $[460] = t33;
    $[461] = t42;
    $[462] = t49;
    $[463] = t60;
    $[464] = t210;
  } else {
    t210 = $[464];
  }
  let t211;
  if ($[465] !== menuPromoBanners || $[466] !== t210 || $[467] !== t5 || $[468] !== t7 || $[469] !== t9) {
    t211 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} sections={t210} />;
    $[465] = menuPromoBanners;
    $[466] = t210;
    $[467] = t5;
    $[468] = t7;
    $[469] = t9;
    $[470] = t211;
  } else {
    t211 = $[470];
  }
  return t211;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('dobirka');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoPaymentOnDelivery']))
    }
  };
};